import createAgencyService from "~/services/agency";
import createAlertService from "~/services/alert";
import createAuditService from "~/services/audit";
import createCertService from "~/services/cert";
import createComputerService from "~/services/computer";
import createConfigService from "~/services/config";
import createDashboardService from "~/services/dashboard";
import createInstanceService from "~/services/instance";
import createNewsService from "~/services/news";
import createTelemetryService from "~/services/telemetry";
import createUserService from "~/services/user";
import createVaccineService from "~/services/vaccine";
import createVersionService from "~/services/version";

export default ({ $axios, store }, inject) => {
  const services = {
    agency: createAgencyService($axios),
    alert: createAlertService($axios),
    audit: createAuditService($axios),
    cert: createCertService($axios),
    computer: createComputerService($axios),
    config: createConfigService($axios),
    dashboard: createDashboardService($axios),
    instance: createInstanceService($axios),
    news: createNewsService($axios),
    telemetry: createTelemetryService($axios),
    user: createUserService($axios),
    vaccine: createVaccineService($axios),
    version: createVersionService($axios),
  };

  inject("services", services);
  store.$services = services;
};
